import { FunctionComponent, isValidElement } from 'react'
import { MdCheck } from 'react-icons/md'

import dimensions from 'shared/styles/dimensions'

import logoTmov from '../../assets/images/logoTmov.svg'
import { colors } from '../../styles/colors'
import Button from '../Button'
import { IFeedbackProps } from './FeedbackComponent.types'
import {
  Container,
  ContainerFeedback,
  Icon,
  Logo,
  StyledCheck,
  StyledText,
} from './styles'

export const Feedback: FunctionComponent<IFeedbackProps> = ({
  showLogo,
  sizeIcon,
  title,
  subTitle,
  body,
  buttonText,
  buttonIcon: ButtonIcon,
  onClickButton,
  className,
  color,
  backgroundColor,
  colorIcon,
  icon,
}) => {
  return (
    <Container className={className} backgroundColor={backgroundColor}>
      <ContainerFeedback>
        {showLogo === undefined || showLogo ? <Logo src={logoTmov} /> : <></>}
        {icon ? (
          <Icon src={icon} />
        ) : (
          <StyledCheck color={colorIcon} size={sizeIcon} />
        )}

        {isValidElement(title) ? (
          title
        ) : (
          <StyledText
            size={dimensions.fontSize.medium + 10}
            weight="700"
            color={color ?? colors.white}
          >
            {title}
          </StyledText>
        )}
      </ContainerFeedback>

      <StyledText
        size={dimensions.fontSize.large}
        color={color ?? colors.white}
      >
        {subTitle}
      </StyledText>

      {isValidElement(body) ? (
        body
      ) : (
        <StyledText
          size={dimensions.fontSize.large}
          color={color ?? colors.white}
        >
          {body}
        </StyledText>
      )}

      <br />
      <Button color={colors.orange} onClick={onClickButton}>
        {ButtonIcon ? <ButtonIcon /> : <MdCheck />}
        {buttonText || 'Concluir'}
      </Button>
    </Container>
  )
}
